import { createContext, useContext, ReactNode } from 'react'
import { Toast, ToastType } from '@components/feedback/Toast'

interface NotificationContextType {
  toasts: Toast[]
  showToast: (
    type: ToastType,
    title: string,
    options?: {
      message?: string
      duration?: number
      dismissible?: boolean
      progress?: number
    }
  ) => string
  updateToast: (id: string, updates: Partial<Toast>) => void
  dismissToast: (id: string) => void
  clearAll: () => void
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined)

export function useNotificationContext() {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotificationContext must be used within NotificationProvider')
  }
  return context
}

interface NotificationProviderProps {
  children: ReactNode
  value: NotificationContextType
}

export function NotificationProvider({ children, value }: NotificationProviderProps) {
  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  )
}
